<template>
  <section class="custom-stepper">
    <i class="fas fa-caret-up" @click.prevent="onClickUp" />
    <i class="fas fa-caret-down" @click.prevent="onClickDown" />
  </section>
</template>
<script>
export default {
  name: 'dt-stepper',
  methods: {
    onClickUp() {
      this.$emit('clickUp')
    },
    onClickDown() {
      this.$emit('clickDown')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-stepper {
  padding: 0;
  margin: 0;
  text-align: center;
  display: inline-flex;
  i {
    height: 18px;
    width: 18px;
    padding: 0;
    text-align: center;
    margin: 0;
    line-height: normal;
    background-color: rgb(233, 233, 233);
    border: 1px solid rgb(192, 192, 192);
    border-radius: 2px;
  }
  i:hover {
    background-color: white;
    border: 1px solid rgb(122, 122, 122);
  }
}
</style>
